<template>
    <div class="page">
      <TipsHbrb ref="child"></TipsHbrb>      
      <PageLoading v-if="loading"></PageLoading>   
        <div class="topBanner">
          <img src="@/assets/images/blind/topImg.png" alt="">
        </div>
        <div class="moreBtn" @click="showPageLink">更多资讯</div>
        <div class="actNote" @click="showNoticePup">活动说明</div>
        <!-- 获得奖品列表 0实物奖品、1电子券码、2口令红包、3微信红包、4纵览积分、5日报积分、6手机话费、7实物票券 -->
        <div class="prizeList">
          <div class="topNav">我的奖品</div>
          <ul v-if="myPrizeList.length>0">
            <li v-for="(val,index) in myPrizeList" :key="index">
              <div class="itemBox">
                <a class="thumb" v-if="val.prize_img"><img :src="val.prize_img" /></a>
                <p class="prizeInfo">
                  <span class="title">
                    {{val.prize_name}} 
                  </span>
                  <span class="timeLine">中奖时间：{{formatTime(val.dateline)}}</span>
                  <span class="timeLine" v-if="val.sncode&&val.prize_type==1">券码内容：{{val.sncode}}</span>
                  <span class="timeLine" v-if="val.sncode&&val.prize_type==2">口令内容：{{val.sncode}}</span>
                  <span class="timeLine" v-if="val.sncode&&val.prize_type==7">票券内容：{{val.sncode}}</span>
                </p>
                <div class="rightbox">
                  
                  
                  <span v-if="val.expired==1" class="expiredPrize">已过期</span>    
                  <span v-if="val.is_save==1 && val.expired==0" class="getPrize had" @click="showInfo(val)">我的信息</span>
                  <span v-if="val.is_save==0 && val.expired==0 && (val.prize_type==0 || val.prize_type==7)" class="getPrize" @click="showInfo(val)">领取奖品</span>    
                  <span v-show="val.sncode&&val.prize_type==1" class="getPrize getCode" @click="copyTxt(val)">复制券码</span>
                  <span v-show="val.sncode&&val.prize_type==2" class="getPrize getCode" @click="copyTxt(val)">复制口令</span>
                  <span v-show="val.sncode&&val.prize_type==7" class="getPrize getCode" @click="copyTxt(val)">复制票券</span>
                </div>
              </div>
              <div class="posterNum" v-if="val.express_code"><div class="express"><i class="huodong icon-kuaidiyunshu"></i> 快递信息 {{val.express_code}} </div><div @click="copyTxt(val)" class="copyBtn"><i class="huodong icon-fenzu"></i> 复制</div></div>   
              <div class="posterNum" v-else-if="val.is_save==0 && (val.prize_type==0 || val.prize_type==7)">待领取</div>
              <div class="posterNum" v-else-if="val.is_save==1 && (val.prize_type==0 || val.prize_type==7)">待邮寄</div>           
            </li>
          </ul>
          <ul v-else><li><p class="noData"><img src="@/assets/images/grid/nodata.png" alt=""><br>暂无奖品</p></li></ul>
        </div>

        <!-- 修改信息窗口 -->
        <van-popup v-model="infoBox" closeable close-icon="close" class="infoBox">
          <van-form @submit="onSubmit">
            <van-field
              v-model="contactData.contact_name"
              name="contact_name"
              label="姓名"
              placeholder="姓名"
              :rules="[{ required: true, message: '请填写姓名' }]"
            />
            <van-field
              v-model="contactData.contact_phone"
              name="contact_phone"
              label="手机号"
              placeholder="手机号"
              :rules="[{ required: true, message: '请填写手机号' }]"
            />
            <van-field
              readonly
              clickable
              name="picker"
              :value="contactData.contact_phone_type"
              label="运营商"
              placeholder="手机运营商"
              @click="showPicker = true"
              v-show="prize_type==6"
            />
            <van-popup v-model="showPicker" position="bottom">
              <van-picker
                show-toolbar
                :columns="columns"
                @confirm="onConfirm"
                @cancel="showPicker = false"
                v-show="prize_type==6"
              />
            </van-popup>
            <!-- <van-field   
              v-model="contactData.contact_company"
              name="contact_company"
              label="单位名称"
              placeholder="单位名称"
              :rules="[{ message: '请填写单位名称' }]"
            /> -->
            <van-field
              v-show="prize_type==0 || prize_type==7"
              v-model="contactData.contact_address"
              name="contact_address"
              label="邮寄地址"
              placeholder="邮寄地址"
              :rules="[{message: '请填写邮寄地址' }]"
            />
            <input type="hidden" name="recordid" v-model="recordid">
            <div style="margin: 16px;">
              <van-button round block type="danger" native-type="submit">提 交</van-button>
            </div>
          </van-form>      
        </van-popup>

        <!-- 活动规则 -->
        <van-popup v-model="showNotice" closeable close-icon="close" round>          
          <div class="noticBox">        
            <h2 class="noticTitle">
              <span class="line"></span>
              <span class="text">活动说明</span>
              <span class="line"></span>
            </h2>
            <div class="noticTxt" v-html="this.actExtend.explain"></div>
          </div>
        </van-popup>
        
        <navBar></navBar>
        <!-- 1电脑端，2微信端，3纵览新闻客户端，4河北日报客户端，5H5端 -->
        <stat :actId="actInfo.lotteryid" :actTitle="actInfo.title" :from="4" v-if="actInfo && actInfo.lotteryid"></stat>
    </div>
</template>

<script>
import TipsHbrb from '@/components/TipsHbrb.vue'
import PageLoading from '@/components/PageLoading.vue'
import navBar from '@/components/navBar.vue'
import stat from '@/components/stat.vue'
import dayjs from 'dayjs'
import { reqLotteryExtend, reqMyprize, reqSubMyinfo } from '@/api/lotteryHbrb.js' //接口方法
import {isWeixin,wxAuthorize} from "@/utils/wx-authorize.js" //微信授权
import { Clipboard } from "v-clipboard";
export default {
  name:"myprinze",
  mixins: [],
  components: {TipsHbrb, PageLoading ,navBar,stat},
  props: {},
  data () {
    return {
      loading: true,
      lotteryid:0,
      accessid:'', 
      openid:'', //微信用户openid  
      accountId: '',
      uniqueId: '',
      openId:'', //微信用户openId
      accessToken: '', //微信用户授权access_token
      actInfo:{},   
      actExtend:{},
      shareImg:"https://img2.hebnews.cn/img/home.53fe0d7.png",
      shareTitle:"",
      shareDesc:"", 
      isWeixin: false, //是否微信内打开
      isLogin: false, //登录状态
      myPrizeList:[],
      //提交信息参数
      infoBox: false,
      needAddress:true,
      prize_type:0,
      recordid:'',
      contactData:{},
      showPicker: false,
      columns: ['中国移动', '中国电信', '中国联通', '中国广电', '其它'],
      nickname: '',
      phone: '',
      address: '',
      contact_name:'',
      contact_phone: '',
      contact_address: '',
      contact_others: '',
      showNotice:false,
    }
  },
  computed: {
    
  },
  watch: {},
  created () {
    this.lotteryid = this.$route.query.lotteryid;
    this.token = this.$store.state.token;
    this.accountId = this.$store.state.accountId;
    this.uniqueId = this.$store.state.uniqueId;
    this.actInfo = this.$store.state.actInfo;
    this.shareImg = this.$store.state.actInfo.share_logo;
    this.shareTitle = this.$store.state.actInfo.share_title;
    this.shareDesc = this.$store.state.actInfo.share_desc;
  },
  mounted() {
    if(this.lotteryid) {
      this.myPrize()
    }else{
      this.$toast({
          icon: 'warning-o',
          message: '活动不存在！'
        });
    }
  },
  methods: {
    showPageLink(){
      window.location.href = "https://hbxw.hebnews.cn/subject.html?id=618726&template=0";   
    },
    showNoticePup() {      
      this.actExtend = this.$store.state.actExtend;
      if(!this.actExtend) {
        this.showNotice = true;
      } else {
        this.loading = true;
        reqLotteryExtend({lotteryid:this.lotteryid}).then(res => {        
          if(res.code==200) {       
            this.loading = false;
            this.actExtend = res.data;   
            this.$store.commit("SET_ACTEXTEND",res.data); 
            this.showNotice = true;
          } else {
            this.loading = false;
            this.$toast({
                icon: 'warning-o',
                message: res.msg
            });
          }
        }).catch(err => {     
          this.loading = false;   
          this.$toast({
              icon: 'warning-o',
              message: err
          });
        }) 
      }
    },
    onConfirm(value, index) {
      this.contactData.contact_phone_type = value;
      this.showPicker = false;
    },
    copyTxt(val) {
      Clipboard.copy(val.sncode);
      this.$toast({
        icon: 'success',
        message: '复制成功'
      }); 
    },
    myPrize() {
      this.loading = true;
      let params = {
        lotteryid:this.lotteryid, 
        hbrb_account_id:this.accountId,
        hbrb_unique_id:this.uniqueId
      }
      reqMyprize(params).then(res => {        
        if(res.code==200) {       
          this.loading = false;
          this.myPrizeList = res.data; 
        } else {
          this.loading = false;
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {        
        this.loading = false;
        this.$toast({
            icon: 'warning-o',
            message: err
        });
      })     
    },
    onSubmit() {
      this.loading = true;
      let params = {};
      params = {...this.contactData, lotteryid:this.lotteryid, recordid:this.recordid, hbrb_account_id:this.accountId, hbrb_unique_id:this.uniqueId};

      reqSubMyinfo(params).then(res => {        
        if(res.code==200) {       
          this.loading = false;
          this.infoBox = false;
          this.recordid = res.data.recordid;
          this.contactData = res.data;
          this.myPrize()
        } else {
          this.loading = false;
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {        
        this.loading = false;
        this.$toast({
            icon: 'warning-o',
            message: err
        });
      })     
    },
    showInfo(val) {
      this.infoBox = true;
      this.recordid = val.recordid;
      this.prize_type = val.prize_type;
      this.contactData = val;
    },    
    formatTime(time) {    
      return dayjs(time*1000).format('YYYY-MM-DD HH:mm')
    },
    toHome(){
      this.$router.push({ path: '/index',query:this.$route.query })
    },    
    toLucky(){
      this.$router.push({ path: '/lottery',query:this.$route.query })
    },
    toMyPrize(){
      this.$router.push({ path: '/myprize',query:this.$route.query })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/myPrize.scss';
</style>
